import React, { FC, useEffect } from 'react';
import {
	fetchNotifications,
	setNotificationsAsRead,
	setNotificationsAsSean,
	useNotificationContext,
} from '../../store/notification-context';
import clsx from 'clsx';
import { Dropdown } from 'rsuite';
import Notice from '@rsuite/icons/Notice';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { NotificationItem } from './header-menus/NotificationItem';

export interface INotification {
	title?: string;
	message?: string;
	seen?: boolean;
	read?: boolean;
	date?: string | number | Date;
	category?: string;
	id?: string | number;
}

export interface INotificationsData {
	unseenCounter?: number;
	notifications?: INotification[];
}

export const HeaderNotification: FC = () => {

	const { notificationContextState: { notificationsData }, dispatch } = useNotificationContext();

	useEffect(() => {
		fetchNotifications(dispatch);
	}, []);

	const markAsSeen = async (): Promise<void> => {
		if (notificationsData?.unseenCounter) {
			setNotificationsAsSean(dispatch);
		}
	};

	const badgeCounter = (): number | string => {
		if (notificationsData?.unseenCounter < 100) {
			return notificationsData.unseenCounter;
		} else {
			return '99+';
		}
	};

	const markAsReed = async (id?: string | number): Promise<void> => {
		setNotificationsAsRead(dispatch, id);
	};
	return (
		<div className="dropdown me-lg-10 position-relative top-bar-notification">
			{
				notificationsData?.unseenCounter > 0 && (
					<div
						className={clsx('notification-badge', notificationsData?.unseenCounter > 99 && 'notification-badge-extra')}>
						{badgeCounter()}
					</div>
				)
			}
			<Dropdown
				icon={<Notice onClick={markAsSeen} />}
				noCaret
				placement="bottomEnd"
				className="top-bar-icon"
			>
				<div className="border-bottom px-5 d-flex align-items-center justify-content-between">
					<div className='d-flex align-items-center'>
						<div>
							Notifications
						</div>
						<div className="text-danger fs-8 ms-2">
							{notificationsData?.unseenCounter ? `${notificationsData?.unseenCounter} new` : null}
						</div>
					</div>
					<Link to="/notifications">
						<Dropdown.Item>
							<FontAwesomeIcon icon={faArrowUpRightFromSquare} className="notification-icon" />
						</Dropdown.Item>
					</Link>
				</div>
				{
					notificationsData?.notifications.length ? (
						<>
							<ul className="dropdown-menu-list border-bottom m-0 p-5">
								{
									notificationsData?.notifications.map((item) => (
										<NotificationItem
											{...item}
											key={item.id}
											markAsReed={markAsReed}
										/>
									))
								}
							</ul>
							<div
								className="text-center my-5 text-muted cursor-pointer fs-7 w-100px ms-auto me-auto"
								onClick={(): Promise<void> => markAsReed()}
							>
								<a href="src/app/components/header/TopBar#">Mark all as read</a>
							</div>
						</>
					) : (
						<div className="p-5 text-center fw-bolder">
							No Notifications
						</div>
					)
				}
			</Dropdown>
		</div>
	);
};